import ReactStrapTable from "components/reactStrapTable";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import HoverImage from "react-hover-image/build";
import ReactSelect from "react-select";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import { cellRendererCheck, dateFormate } from "utils/columns";
import { OverlayTrigger } from "react-bootstrap";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from "assets/icon/calendar-icon.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import ErrorBoundary from "components/ErrorBoundary";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField copy";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import useContextService from "hooks/useContextService";
import { ModuleAccess } from "utils/moduleaccess";
import cancel from "assets/icon/cancel.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import plus from "assets/icon/plus-icon.svg";



let tableDataBackup = [
  {
    chainPharmacy: "123445",
    pharmacy: "123445",
    npi: "123445",
    ncpdPandNABP: "123445",
    pharmacyAddress: "123445",
    pharmacyLiveDate: "123445",
    pharmacyTerminationDate: "123445",
    claimsProcessDate: "123445",
  },
];
let rowForEdit = {};
let updatedFields = {};

let hasDatePopupOpen = false;

const Location = (props) => {
  const {
    states: { configLocationType },
    setStates,
  } = useContextService();
  const { search, } = configLocationType;
  let location340b = [
    {
      "id": "Yes",
      "label": "Yes"
    },
    {
      "id": "No",
      "label": "No"
    }
  ]

  const { rowData, orgId, SelectedAccumulator, keyname, setLoading,
    loading, } = props

  const EligibleLocation = [
    { id: "Y", label: "Yes" },
    { id: "N", label: "No" },
  ]
  let initialStates = {
    currentPage: 1,
    pageSize: 100,
    order: 'desc',
    orderBy: 'modifiedDate',
    Filters: [],
    AccumulatorID: SelectedAccumulator
  }

  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState([])
  const [data, setData] = useState([]);

  const [modal, setModal] = useState(false);
  const [showLocationAdd, setLocationAdd] = useState(true);
  const [active, setActive] = useState(true);
  const [serviceLocation, SetServiceLocation] = useState("")
  const [locationDesc, setLocationDesc] = useState("")
  const [eligibleLocation, SetEligibleLocation] = useState([])
  const [SelectedEligibleLocation, SetSelectedEligibleLocation] = useState("")
  const [locationerror, setLocationError] = useState("")
  const [locationdescerror, setLocationdescError] = useState("")
  const [eligiblelocationerror, setEligibleLocationError] = useState("");
  const [hasTouched, setTouched] = useState('');
  // const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [originalData, setOriginalData] = useState({});
  const [ishiddenflag, setIshiddenflag] = useState(false);

  const toggle = () => setModal(!modal);

  const editRow = (rowData, isEdit = true) => {


    if (isEdit == false) {
      setIshiddenflag(false);
    }
    let tempData = [...tableData];
    if (isEdit) {
      setOriginalData({ ...rowData });
    }
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.serviceLocationID === rowData?.serviceLocationID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setTouched('');
    updatedFields = {};
    setData(tempData);
  };


  const cellRenderEdit = (rowData) => {
    if (rowData.isEdit) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={toggle}
            //disabled={}
            hidden={!ishiddenflag}
            title="Save"
          >
            <HoverImage
              key="SaveIcon"
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt="Save"
            />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(rowData, false)}
            title="Cancel"
          >
            <HoverImage
              key="CancelIcon"
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt="Cancel"
            />
          </Button>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center">
          {renderEditLButton1(rowData)}
        </div>
      );
    }
  };


  const checkvalidation = (selectedvaluesonly) => {
    debugger;
    if (selectedvaluesonly.serviceLocationName == null || selectedvaluesonly.serviceLocationName == "") {
      toast.error('Service Location Description is a required field');
      return true;
    }
    else if ((selectedvaluesonly.isMixedUseArea == undefined || selectedvaluesonly.isMixedUseArea == null || selectedvaluesonly.isMixedUseArea == "" ||selectedvaluesonly.isMixedUseArea == "-")) {
      toast.error('340B Eligible Location is a required field');
      return true;
    }
    // else if ((selectedvaluesonly.inactiveFlag == undefined || selectedvaluesonly.inactiveFlag == null || selectedvaluesonly.inactiveFlag == "")) {
    //     toast.error('Active  is requied');
    //     return true;

    // }
    else {
      return false;
    }
  }
  const savePanelUpdateRow = async () => {

    setIshiddenflag(false);
    toggle();
    if (checkvalidation(rowForEdit))
      return true;

    setLoading(true);

    const payload = { ...rowForEdit };
    delete payload.isEdit;
    payload.AccumulatorID = SelectedAccumulator
    if (SelectedAccumulator) {
      try {
        const result = await API.post(
          `SBTenant/${orgId.tenantID}/Configuration/EditLocation`,
          payload,
          {
            hasDefaultURL: true,
          },
        );

        if (result) {

          if (result.data.error) {
            toast.error(result.data.message);

          }
          else {
            toast.success('Location Updated Successfully');
            // fetchlocation(search);
          }
          setLoading(false);
          handelLocation();
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    setLoading(false);
  };

  const API = useAxios()
  useEffect(() => {
    handelLocation(initialStates)
  }, [rowData, keyname]);

  const handelLocation = async (filterObj) => {
    debugger
    if(keyname ==="locationTab"){
    if (filterObj != undefined) {
      initialStates.Filters = filterObj.Filters
      initialStates.order = filterObj.order ? filterObj.order : initialStates.order
      initialStates.orderBy = filterObj.orderBy ? filterObj.orderBy : initialStates.orderBy
      initialStates.currentPage = filterObj.currentPage ? filterObj.currentPage : initialStates.currentPage
      filterObj.AccumulatorID = filterObj.AccumulatorID ? filterObj.AccumulatorID : initialStates.AccumulatorID
    }
    if (filterObj == undefined) {
        filterObj = initialStates
    }
    setLoading(true);
    if (initialStates?.AccumulatorID) {

      try {
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/Configuration/locationlist`, filterObj, {

          hasDefaultURL: true,
        });
        if (data?.items?.length > 0) {
          setTableData(data.items);
          setTotalRecords(data.totalRecords);
        }
        else{
          setTableData([]);
          setTotalRecords(0);
        }
        setLoading(false);
      }
      catch (error) {
        setLoading(false);

        //. console.log(error.Message);
      }
    
    // }
    setLoading(false);
  }
  }
}
  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
  }
  const renderEditLButton1 = (rowData) => {
    if (hasPermission('ED'))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => editRow(rowData)}
        title="Edit"
      >
        <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
      </Button>
    );
  };
  const handleSubmit = async () => {
    //
    let AddLocationEntity = []
    let activedata = ""
    if (serviceLocation.length == 0) {
      setLocationError("Service Location Code is a required field")
    }
    if (locationDesc.length == 0) {
      setLocationdescError("Service Location Description is a required field")
    }
    if (SelectedEligibleLocation.length == 0) {
      setEligibleLocationError("340B Eligible Location is a required field")
    }
    if (SelectedEligibleLocation.length > 0) {
      setEligibleLocationError("")
    }
    if (active == true) {
      activedata = "Y"
    }
    if (active == false) {
      activedata = "N"
    }

    var lst = {};

    lst.ServiceLocationCode = serviceLocation,
      lst.ServiceLocationName = locationDesc,
      lst.IsMixedUseArea = SelectedEligibleLocation,
      lst.InactiveFlag = activedata,
      AddLocationEntity.push(lst)
    // setLoading(true);

    if (serviceLocation.length > 0 && locationDesc.length > 0 && SelectedEligibleLocation.length > 0) {
      try {

        const result = await API.post(`SBTenant/${orgId.tenantID}/Configuration/Addlocation/${SelectedAccumulator}`, { AddLocationEntity },
          {
            hasDefaultURL: true,
            hideLoader: true,
          }
        );
        if (result) {

          if (result.data[0].success === false) {
            toast.error(result.data.message);
            setErrorMessage("Service Location already exists");
          }
          else {
            toast.success('Location Add Successfully');
            handelLocation();
            handelCancel();
            refetch();
          }
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    }

    // setLoading(false);
  }

  const handlePageChange = (filter, haveColFilter) => {
    updateLocationSearch(filter);
    const filterObj = cloneDeep(search);
    if (haveColFilter) {
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      handelLocation(filterObj);
    } else {
      handelLocation(filterObj);
    }
  };

 const updateLocationSearch = (filter) => {
    search.currentPage= filter.currentPage;
    search.pageSize= filter.pageSize;
    search.order= filter.order;
    search.orderBy= filter.orderBy;
  }

const [columnFilters, setColumnFilters] = useState([]);
  const handleSearchColumnFilters = async (colFilter) => {
    const filterObj = cloneDeep(search);
    if (colFilter && colFilter.length > 0) {
      filterObj.filters = [...filterObj.filters, ...colFilter];
      setColumnFilters(colFilter);
    }
    await handelLocation(filterObj);
  };

  const handleFilterCancel = (filterObj) => {
    setColumnFilters([]);
    filterObj= cloneDeep(search);
    handelLocation(filterObj)
    // refetch();
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const updateRowValue = (value, col) => {

    const tempRow = { ...rowForEdit };
    if ((originalData.serviceLocationName == value && originalData.isMixedUseArea == tempRow.isMixedUseArea && originalData.inactiveFlag == tempRow.inactiveFlag) || (originalData.isMixedUseArea == value && originalData.inactiveFlag == tempRow.inactiveFlag && originalData.serviceLocationName == tempRow.serviceLocationName) || (originalData.inactiveFlag == value && originalData.serviceLocationName == tempRow.serviceLocationName && originalData.isMixedUseArea == tempRow.isMixedUseArea)) {
      setIshiddenflag(false);
      tempRow[col] = value;
      rowForEdit = tempRow;
    }
    else if (tempRow.serviceLocationName != value || tempRow.isMixedUseArea != value) {
      setIshiddenflag(true);
      tempRow[col] = value;
      rowForEdit = tempRow;
    }


  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "statusList") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          hasTouched={hasTouched}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          listArray={location340b}
          requiredFields={formatterType}
        />
      );
    }
    if (formatterType == "checkbox") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    }
    else {
      return (
        <CellEditRender
         row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          requiredFields={formatterType}
        />
      );
    }
  };

  const renderCheckBox = (rowData, col) => {
    return (
      <Input
        className="text-primary p-0 text-decoration-none"
        type="checkbox"
        checked={rowData.inactiveFlag === "N"}
        disabled={!rowData.isEdit}
        title="Active"
      />
    );
  };

  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 85,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "serviceLocationCode",
      text: "Service Location Code ",
      sort: true,
      width: 180,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.serviceLocationCode),
    },
    {
      dataField: "serviceLocationName",
      text: "Service Location Description",
      sort: true,
      width: 220,
      show: true,
      inputType: "text",
      edit: true,
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "text"),
    },
    {
      dataField: "isMixedUseArea",
      text: "340B Eligible Location",
      sort: false,
      width: 90,
      show: true,
      inputType: "text",
      edit: true,
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "statusList"),
    },
    {
      dataField: "inactiveFlag",
      text: "Active",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      edit: true,
      hideColFilter: false,
      //cellRenderer: (row, col) => renderCheckBox(row, col),
      cellRenderer: (rowData, col) => rowData.isEdit === true ? formatter(rowData, col, "checkbox", true) : renderCheckBox(rowData, col)

    },
    {
      dataField: "pendingCount",
      text: "Pending Count",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.pendingCount !== 0 ? row.pendingCount : "0"),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: false,
      // edit: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 100,
      show: true,
      inputType: "date",
      hideColFilter: false,
      edit: true,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },


  ];
  const handelClick = () => {
    setLocationAdd(false);
  };
  const handelCancel = () => {
    setLocationAdd(true);
    setLocationDesc("");
    SetServiceLocation("");
    SetSelectedEligibleLocation("");
    setLocationError("");
    setEligibleLocationError("");
    setLocationdescError("");
    setErrorMessage("");
  };

  const handelServiceLocation = (e,) => {
    const { value } = e.target;
    // setFieldValue('patientstatus', value);
    if (value.length > 0) {
      setLocationError("")
    }
    SetServiceLocation(value)
    // addPatientData.patientstatus=value
  }
  const handellocationDesc = (e,) => {
    const { value } = e.target;
    // setFieldValue('patientstatus', value);
    if (value.length > 0) {
      setLocationdescError("")
    }
    setLocationDesc(value)
    // addPatientData.patientstatus=value
  }
  const handelEligibleLocation = (e,) => {
    const { value } = e.target;
    // setFieldValue('eligibleloc', value);
    if (value.length > 0) {
      setEligibleLocationError("")
    }
    SetSelectedEligibleLocation(value)
    // addPatientData.patientstatus=value
  }
  const handelActive = (event) => {
    setActive(event.target.checked)

  }
  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(search);
    filterObj.AccumulatorID = SelectedAccumulator;
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }
    // const { access_token } =
    //     JSON.parse(localStorage.getItem('pharmaforce')) || {};
    // const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/DrugCatalog/ExportAll?access_token=${access_token}`;
    // onExport(action, filterObj);
    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "location";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  return (
    <div>
      <div>
        <Formik
          // initialValues={initialValues}
          onSubmit={handleSubmit}
          // validationSchema={validationSchema}
          // enableReinitialize={true}
          children={(props) => {
            // const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
            return (
              <div hidden={showLocationAdd}>
                <Row sm={5}>
                  <Col md={4} lg={4} sm={4} xs={4}>
                    {" "}
                    <FormGroup>
                      <Label for="servicelocation">Service Location Code</Label>
                      <Input
                        className="required"
                        id="servicelocation"
                        name="servicelocation"
                        type="text"
                        placeholder="Enter Service Location Code"
                        autoComplete="off"
                        value={serviceLocation}
                        component={FormikInputField}
                        onChange={(e) => { handelServiceLocation(e) }}
                      />
                      {locationerror && <div className="text-danger font-size-12">{locationerror}</div>}
                    </FormGroup>
                  </Col>

                  <Col md={4} lg={4} sm={4} xs={4}>
                    {" "}
                    <FormGroup>
                      <Label for="servicelocationdesc">Service Location Description</Label>
                      <Input
                        className="required"
                        id="servicelocationdesc"
                        name="servicelocationdesc"
                        type="text"
                        placeholder="Enter Service Location Description"
                        autoComplete="off"
                        value={locationDesc}
                        component={FormikInputField}
                        onChange={(e) => { handellocationDesc(e,) }}
                      />
                      {locationdescerror && <div className="text-danger font-size-12">{locationdescerror}</div>}
                    </FormGroup>
                  </Col>
                  <Col md={4} lg={4} sm={4} xs={4}>
                    {" "}
                    <FormGroup>
                      <Label for="340B Eligible Location">340B Eligible Location</Label>
                      <Field
                        className="required"
                        id='eligibleloc'
                        name='eligibleloc'
                        type='select'
                        placeholder="Select Location "
                        autoComplete='off'
                        options={EligibleLocation}
                        value={SelectedEligibleLocation}
                        component={FormikSelectField}
                        // onKeyUp={handleStateData}
                        defaultoption='--Select--'
                        keys={{
                          id: 'id',
                          label: 'label',
                        }}
                        onChange={(e) => handelEligibleLocation(e)}
                      />
                      {eligiblelocationerror && <div className="text-danger font-size-12">{eligiblelocationerror}</div>}
                    </FormGroup>

                  </Col>
                  <Col md={4} lg={4} sm={4} xs={4}>
                    {" "}
                    <FormGroup>
                      <Label for="active">Active</Label>
                      <Input
                        id="active"
                        name="active"
                        type="checkbox"
                        autoComplete="off"
                        checked={active}
                        // component={showLocationAdd}
                        style={{
                          marginLeft: "15px",
                          border: "1px solid black",
                        }}
                        onChange={(event) => {
                          handelActive(event)
                        }}
                      />
                    </FormGroup>
                  </Col>


                </Row>
                <Row>
                  <Col sm={6}>
                    {errorMessage ? (
                      <div
                        style={{
                          display: "inline-block",
                          backgroundColor: "#ffe6e6",
                          // padding: "5px",
                        }}
                        className="text-danger f-12"
                      >
                        {errorMessage}
                      </div>
                    ) : null}
                  </Col>
                </Row>

                <Row style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Col md="auto" className="">
                    <Label>{""}</Label>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="search"
                      onClick={handleSubmit}

                    // disabled={!coveredEntityid}
                    // hidden={!hasPermission("AD")}
                    >
                      <span className="right_5"><img src={save} alt="" /></span>{" "}

                      Save
                    </Button>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="reset"
                      onClick={handelCancel}

                    // disabled={!coveredEntityid}
                    // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5"><img src={CancleIcon} alt="" /></span>

                      Cancel
                    </Button>
                  </Col>
                </Row>
              </div>
            );
          }}
        ></Formik>

        <Formik
          // initialValues={initialValues}
          // onSubmit={handleSubmit}
          // validationSchema={validationSchema}
          // enableReinitialize={true}
          children={(props) => {
            // const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
            return (
              <div hidden={!showLocationAdd} style={{position:"absolute",right:"15px",top:"15px",}}>
                <Row sm={5} style={{ justifyContent: "flex-end" }}>
                  <Col md="auto" className="">
                    <Label>{""}</Label>

                    <Button
                      // hidden={isAddPermission}
                      disabled={!SelectedAccumulator}
                      onClick={handelClick}
                      color="primary"
                      className="reset"
                      // disabled={!coveredEntityid}
                      hidden={!hasPermission("AD")}
                    >
                      <span className="right_5">
                        {" "}
                        <img src={plus} alt="" />
                      </span>{" "}
                      Add
                    </Button>
                  </Col>
                </Row>
              </div>
            );
          }}
        ></Formik>
        <div
          className="table-card scroll-table position-relative border-0 rounded pt-2"
          fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
        >
          <ReactStrapTable
            id="location-table"
            height={650}
            // loading={loading}
            fixedColumn
            width={1200}
            // reset={reset}
            // hasPagination
            data={tableData}
            columns={mainCol}
            onExport={handleExport}
            filters={initialStates}
            totalRecords={totalRecords}
            pageSize={initialStates.pageSize}
            currentPage={initialStates.currentPage}
            handleSort={handlePageChange}
            // onPageChange={onHandlePageChange}
            // onPageSizeChange={onPageSizeChange}
            onFilterCancel={handleFilterCancel}
            onSearchColumnFilters={handleSearchColumnFilters}
            display={true}
          // hasExportPermission={hasExportPermission}
          />
        </div>
        <div>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className="modal-header-primary" toggle={toggle}>Location Change</ModalHeader>
            <ModalBody className="custom-modal-body">
              {rowForEdit.inactiveFlag == 'N' ? (
                <p> This change will be applied both historically and going forward. Affected records will be reprocessed.
                  {/* <a href="mailto:support@thepharmaforce.com" class="custom-link">support@thepharmaforce.com</a>. */}
                </p>
              ) : (
                <p> This change will be effective going forward, to reprocess charges in the past please submit a ticket to{' '}
                  <a href="mailto:support@thepharmaforce.com" class="custom-link">support@thepharmaforce.com</a>.
                </p>
              )}
              <div className="modal-buttons">
                <Button className="search" color="primary" onClick={savePanelUpdateRow}>
                  <span className="right_5"><img src={save} alt="" /></span>
                  {" "}

                  OK</Button>
                <Button className="reset" color="primary" onClick={toggle}>
                  <span className="right_5"><img src={cancel} alt="" /></span>
                  {" "}
                  Cancel</Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>

    </div>
  );
};

export default Location;
